import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function ThreatProtection({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding-top:64px;display:flex;flex-direction:column")}>
      <div style={sx("padding:0 20px 22px;display:flex;align-items:center;justify-content:space-between;gap:12px")}>
        <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
          Protect
        </span>
      </div>
      <div style={sx("flex:1;overflow:auto;padding:0 20px 20px;display:flex;flex-direction:column;gap:12px")}>
        <div style={sx("padding:18px;border-radius:var(--radius-lg);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;flex-direction:column;gap:14px")}>
          <span style={sx("display:flex;align-items:center;gap:10px")}>
            <span style={sx("width:20px;height:20px;background:var(--text-primary);-webkit-mask:url(/assets/icons/threat-protection.svg) center/contain no-repeat;mask:url(/assets/icons/threat-protection.svg) center/contain no-repeat")} />
            <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium);flex:1")}>
              Threat Protection Pro
            </span>
            <span style={sx("height:24px;padding:0 10px;border-radius:var(--radius-full);background:var(--bg-success-subtle);color:var(--text-success);font-size:var(--fs-2xs);font-weight:var(--fw-medium);display:flex;align-items:center")}>
              On
            </span>
          </span>
          <span style={sx("display:flex;gap:24px")}>
            <span style={sx("display:flex;flex-direction:column")}>
              <span style={sx("font-size:var(--fs-4xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
                312
              </span>
              <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
                trackers blocked
              </span>
            </span>
            <span style={sx("display:flex;flex-direction:column")}>
              <span style={sx("font-size:var(--fs-4xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
                {v.kBlockCount}
              </span>
              <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
                threats blocked
              </span>
            </span>
          </span>
        </div>
        <div style={sx("display:flex;flex-direction:column;gap:8px")}>
          {v.memberFeatureRows.map((f) => (
            <button
              key={f.id}
              onClick={f.toggle}
              style={sx(
                "padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);" +
                  "border:1px solid var(--border-secondary);display:flex;align-items:center;gap:12px;" +
                  "width:100%;text-align:left;font-family:inherit;color:var(--text-primary);cursor:pointer"
              )}
            >
              <span
                style={sx(
                  `width:18px;height:18px;flex:none;background:${f.on ? "var(--text-primary)" : "var(--text-disabled)"};` +
                    `-webkit-mask:url(${f.icon}) center/contain no-repeat;` +
                    `mask:url(${f.icon}) center/contain no-repeat`
                )}
              />
              <span style={sx(`font-size:var(--fs-sm);flex:1;color:${f.on ? "var(--text-primary)" : "var(--text-secondary)"}`)}>
                {f.name}
              </span>
              <span
                style={sx(
                  `width:44px;height:26px;flex:none;border-radius:var(--radius-full);` +
                    `background:${f.trackBg};position:relative;transition:background 150ms var(--ease-out)`
                )}
              >
                <span
                  style={sx(
                    `position:absolute;top:3px;${f.knobSide};width:20px;height:20px;` +
                      `border-radius:var(--radius-full);background:#fff`
                  )}
                />
              </span>
            </button>
          ))}
        </div>
      </div>
      <div style={sx("height:82px;flex:none;border-top:1px solid var(--border-secondary);background:var(--bg-secondary);display:flex;align-items:flex-start;padding:12px 8px 0")}>
        <button onClick={v.kTabConnect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat;mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Connect
          </span>
        </button>
        <button onClick={v.kTabProtect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-accent);-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-accent);font-weight:var(--fw-medium)")}>
            Protect
          </span>
        </button>
        <button onClick={v.kTabMonitor} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;mask:url(/assets/icons/security-score.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Monitor
          </span>
        </button>
      </div>
    </div>
  )
}
